import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ACCOUNT_LOGIN_ROUTE,
  DEFAULT_ROUTE_CONSTANT,
  DESTINATION_KEY_CONSTANT,
  LOGIN_OBJECT_KEY_CONSTANT,
  PRODUCT_KEY_CONSTANT,
} from '../constants/routes.constant';

@Component({
    selector: 'app-email-verification-complete',
    templateUrl: './email-verification-complete.component.html',
    styleUrls: ['./email-verification-complete.component.scss'],
    standalone: false
})
export class EmailVerificationCompleteComponent {
  private logInRoute: string = ACCOUNT_LOGIN_ROUTE;
  private productNameKey: string = PRODUCT_KEY_CONSTANT;
  private destinationKey: string = DESTINATION_KEY_CONSTANT;
  private loginObjectKey: string = LOGIN_OBJECT_KEY_CONSTANT;
  private productName!: string;
  private destination!: string;
  private loginObject!: string;
  public queryParams: { [key: string]: string } = {
    [this.productNameKey]: this.productName,
    [this.destinationKey]: this.destination,
    [this.loginObjectKey]: this.loginObject,
  };

  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.productName = this.activatedRoute.snapshot.queryParamMap.get(
      this.productNameKey
    )!;
    this.destination = this.activatedRoute.snapshot.queryParamMap.get(
      this.destinationKey
    )!;
    this.loginObject = this.activatedRoute.snapshot.queryParamMap.get(
      this.loginObjectKey
    )!;

    if (!this.productName || !this.destination) {
      this.router.navigate(DEFAULT_ROUTE_CONSTANT, {
        queryParams: this.queryParams,
        queryParamsHandling: 'preserve',
      });
    }

    this.queryParams = {
      [this.productNameKey]: this.productName,
      [this.destinationKey]: this.destination,
      [this.loginObjectKey]: this.loginObject,
    };
  }

  public goToLogin() {
    this.router.navigate(['/', ...this.logInRoute.split('/')], {
      queryParams: this.queryParams,
      queryParamsHandling: 'preserve',
    });
  }
}
